import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
export default ProtoBaseModel.extend({
  r: attr(Number),
  g: attr(Number),
  b: attr(Number),
  a: attr(Number),
  // TODO: make 'a' default to 255

  toRGBA() {
    const aRound = Math.round(this.a * 100 / 255) / 100;
    return `rgba(${this.r}, ${this.g}, ${this.b}, ${aRound})`;
  },
  toRGB() {
    return `rgb(${this.r}, ${this.g}, ${this.b})`;
  },
  // converts a number to a hex and prepends a 0 if is it only one digit long
  _toPaddedHex(num) {
    const hex = num.toString(16);
    if (hex.length === 1) {
      return `0${hex}`;
    } else {
      return hex;
    }
  },
  toHexRGB() {
    return `#${this._toPaddedHex(this.r)}${this._toPaddedHex(this.g)}${this._toPaddedHex(this.b)}`;
  },
  toHexARGB() {
    return `#${this._toPaddedHex(this.a)}${this._toPaddedHex(this.r)}${this._toPaddedHex(this.g)}${this._toPaddedHex(this.b)}`;
  }
}).reopenClass({
  createFromHex(hex) {
    // Remove the # character if it exists
    const cleanedHex = hex.replace('#', '');
    const parsedColor = Number.parseInt(cleanedHex, 16);
    let a, b, g, r;
    if (cleanedHex.length === 3) {
      // format is #RGB or RGB
      a = 255;
      r = parsedColor >> 4 & 255;
      g = parsedColor >> 2 & 255;
      b = parsedColor & 255;
    } else if (cleanedHex.length === 6) {
      // format is #RRGGBB or RRGGBB
      a = 255;
      r = parsedColor >> 16 & 255;
      g = parsedColor >> 8 & 255;
      b = parsedColor & 255;
    } else if (cleanedHex.length === 8) {
      // format includes alpha #AARRGGBB or AARRGGBB
      a = parsedColor >> 24 & 255;
      r = parsedColor >> 16 & 255;
      g = parsedColor >> 8 & 255;
      b = parsedColor & 255;
    } else {
      return this.create();
    }
    return this.create({
      a,
      r,
      g,
      b
    });
  }
});